import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as license from "../../../../constants/license";
import * as handlers from "../../../../constants/handlers";
import * as globalActions from "../../../../actions/globalActions";
import * as licenseActions from "../../../../actions/licenseActions";

import imgLoader from "../../../../resources/img/loader.svg";
import imgSkip from "../../../../resources/img/svgicons/skip.svg";
import imgNext from "../../../../resources/img/svgicons/arrow-right-circle.svg";
import imgBack from "../../../../resources/img/svgicons/arrow-left-circle.svg";
import Button, {BUTTON_SMALL} from "../../../global/generic/Button";

class LicenseProductForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            productId: null
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.productList.length > 0 && prevState.productId === null) {
            if (nextProps.onlineActivation) {
                let index;
                for (index in nextProps.productList) {
                    if (
                        nextProps.productList[index].availableCount !== undefined &&
                        nextProps.productList[index].availableCount > 0
                    ) {
                        return {
                            productId: nextProps.productList[index].id
                        };
                    }
                }
                return {
                    productId: null
                };
            } else {
                return {
                    productId: nextProps.productList[0].id
                };
            }
        }

        return null;
    }

    getProductById = (id) => {
        let product;
        for (product of this.props.productList) {
            if (product.id === id) {
                return product;
            }
        }

        return null;
    };

    handleProductChange = (event) => {
        this.setState({
            productId: Number(event.target.value)
        });
    };

    handleGoBackButtonClick = () => {
        this.props.dispatchGoBackAction(this.props.processStep - 1);
    };

    handleConfirmProductFormClick = () => {
        let product = this.getProductById(this.state.productId);

        if (product !== null) {
            this.props.dispatchSetProductAction(product);
        }
    };

    handleContinueToRedlikeClick = () => {
        this.props.dispatchStartSoftwareInitializationAction();
    };

    getProductRadioButtons = () => {
        let radioButtons = [];

        let licenseProduct;
        for (licenseProduct of this.props.productList) {
            if (this.props.onlineActivation) {
                if (licenseProduct.availableCount !== undefined && licenseProduct.availableCount > 0) {
                    radioButtons.push(
                        <div className="col-xs-10" key={licenseProduct.id}>
                            <label className="radio-style">
                                {licenseProduct.name}
                                <input
                                    className="radio"
                                    type="radio"
                                    name="product"
                                    value={licenseProduct.id}
                                    checked={this.state.productId === licenseProduct.id}
                                    onChange={this.handleProductChange}
                                />
                                <span className="checkmark" />
                            </label>
                        </div>
                    );
                } else {
                    radioButtons.push(
                        <div className="col-xs-10" key={licenseProduct.id}>
                            <label className="radio-style">
                                {licenseProduct.name}
                                <span className="no-license unit-format-margin padding-left-5">
                                    (<Translate value="license.noLicenseAvailable" />)
                                </span>
                                <input
                                    className="radio"
                                    type="radio"
                                    name="product"
                                    value={licenseProduct.id}
                                    checked={false}
                                    disabled
                                />
                                <span className="checkmark" />
                            </label>
                        </div>
                    );
                }
            } else {
                radioButtons.push(
                    <div className="col-xs-10" key={licenseProduct.id}>
                        <label className="radio-style">
                            {licenseProduct.name}
                            <input
                                className="radio"
                                type="radio"
                                name="product"
                                value={licenseProduct.id}
                                checked={this.state.productId === licenseProduct.id}
                                onChange={this.handleProductChange}
                            />
                            <span className="checkmark" />
                        </label>
                    </div>
                );
            }
        }

        return radioButtons;
    };

    getProductForm = () => {
        if (this.props.loading) {
            return (
                <div className="form-box-dark-blue row flex-child fill-flex-space">
                    <div className="col-xs-12 text-center">
                        <img alt="loading" src={imgLoader} />
                    </div>
                </div>
            );
        }

        const radioButtons = this.getProductRadioButtons();
        if (radioButtons.length) {
            return (
                <div className="form-box-dark-blue row flex-child fill-flex-space">
                    <div className="col-xs-12 license-text">
                        <Translate value="license.selectProduct" />
                    </div>
                    <div className="col-xs-12 radio-buttons-block">{radioButtons}</div>
                </div>
            );
        }

        return (
            <div className="form-box-dark-blue row flex-child fill-flex-space">
                <div className="col-xs-12 license-text">
                    <Translate value="license.noProductsForKey" />
                </div>
            </div>
        );
    };

    getContinueButton = () => {
        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value="general.continue" />}
                onClick={this.handleConfirmProductFormClick}
                svgBefore={imgNext}
                disabled={this.state.productId === null}
            />
        );
    };

    getSkipNewLicenseButton = () => {
        if (this.props.setupSoftware || this.props.licenseStatus !== license.STATUS_VALID_LEASED_LICENSE) {
            return "";
        }

        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value="general.skip" />}
                onClick={this.handleContinueToRedlikeClick}
                svgBefore={imgSkip}
            />
        );
    };

    render() {
        return (
            <div className="flex flex-column flex-child fill-flex-space">
                {this.getProductForm()}
                <div className="col-12 flex flex-align-center flex-gap-3vh margin-bottom-10">
                    <Button
                        size={BUTTON_SMALL}
                        label={<Translate value="general.back" />}
                        svgBefore={imgBack}
                        onClick={this.handleGoBackButtonClick}
                    />
                    {this.getContinueButton()}
                    {this.getSkipNewLicenseButton()}
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        setupSoftware: store.module.setupSoftware,
        licenseStatus: store.license.licenseStatus,
        processStep: store.license.processStep,
        onlineActivation: store.license.onlineActivation,
        productList: store.license.productList,
        loading: store.server.requests.some(
            (request) =>
                request.method === handlers.GET_AVAILABLE_LICENSE_PRODUCTS ||
                request.method === handlers.GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED
        )
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchStartSoftwareInitializationAction: () => {
            dispatch(globalActions.startSoftwareInitialization());
        },
        dispatchSetProductAction: (product) => {
            dispatch(licenseActions.setProduct(product));
        },
        dispatchGoBackAction: (toStep) => {
            dispatch(licenseActions.setStep(toStep));
        }
    };
};

export default LicenseProductForm = connect(mapStoreToProps, mapDispatchToProps)(LicenseProductForm);
